import React, { useState, useEffect } from "react";
import Header from "../component/Header";
import MultiBets from "../component/MultiBets";
import BestBet from "../component/Bestbet";
import Treblewin from "../component/Treblewin";
import Footer from '../component/Footer';
// import Banner from '../component/Banner';
// import Video from '../component/Video';
// import LiveSoccerSpin from '../component/LiveSoccerSpin';
// import LiveSoccer from '../component/LiveSoccer';
// import DidYou from '../component/DidYou';
// import RightLiveSoccerSpin from '../component/RightLivesoccerSpin';
import { fetchJoinUserApi, fetchMultibetleaguesDataApi, fetchSubscriptionCheckIpApi } from "../api/api";

function Firstpage() {
  const [clickCount, setClickCount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [showThankYouMessage, setShowThankYouMessage] = useState("");
  const [oddsFormat, setOddsFormat] = useState("EU");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    tools: [],
    findUsefull: "",
    improved: "",
    type: 3,
  });
  const [leagueData, setLeagueData] = useState([]);
  const [blockPopup, setBlockPopup] = useState(false);
  const [language, setLanguage] = useState("30");



  useEffect(() => {
    const fetchIP = async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        // setIP(data.ip);

        // 🔹 Check if IP exists in backend
        if (data.ip) {
          try {
            const res = await fetchSubscriptionCheckIpApi(data.ip);

            if (res?.statuscode === 200) {
              setBlockPopup(true);
            }
          } catch (err) {
            console.error("Error checking IP:", err);
          }
        }
      } catch (err) {
        console.error("Error fetching IP:", err);
      }
    };

    fetchIP();
  }, []);

  // console.log(ip)

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handlePageClick = () => {
    if (blockPopup) return;
    setClickCount((prev) => {
      const updated = prev + 1;
      if (updated === 18) {
        setShowPopup(true);
      }
      return updated;
    });
  };

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showPopup]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    const submittedData = {
      ...formData,
      tools: formData.tools.join(", "),
    };

    try {
      const response = await fetchJoinUserApi(submittedData);
      if (response?.message) {
        setShowThankYouMessage(response.message);
      } else {
        setShowThankYouMessage("Submitted successfully.");
      }

      // console.log(clickCount)

      setFormData({
        tools: [],
        findUsefull: "",
        improved: "",
        email: "",
        type: 1,
        name: "",
      });
      setBlockPopup(true);

      setTimeout(() => {
        setShowPopup(false);
      }, 5000);
    } catch (err) {
      setEmailError("Something went wrong. Please try again.");
    }
  };

  const handleClose = () => {
    setShowPopup(false);
    setEmailError("");
    setFormData({
      name: "",
      email: "",
      tools: [],
      findUsefull: "",
      improved: "",
      type: 3,
    });
  };

  useEffect(() => {
    const fetchLeagueData = async () => {
      try {
        const leagueData = await fetchMultibetleaguesDataApi(language);
        const data = leagueData.data;
        setLeagueData(data);
      } catch (error) {
        console.error("Error fetching league data:", error);
      }
    };
    fetchLeagueData();
  }, [language]);

  useEffect(() => {
    const blockActions = (e) => {
      e.preventDefault();
    };

    document.addEventListener("copy", blockActions);
    document.addEventListener("cut", blockActions);
    // document.addEventListener("contextmenu", blockActions);
    document.addEventListener("selectstart", blockActions);

    return () => {
      document.removeEventListener("copy", blockActions);
      document.removeEventListener("cut", blockActions);
      // document.removeEventListener("contextmenu", blockActions);
      document.removeEventListener("selectstart", blockActions);
    };
}, []);


  return (
    <div className="BL-affiliates" onClick={handlePageClick}>
      <Header oddsFormat={oddsFormat} setOddsFormat={setOddsFormat} setLanguage={setLanguage} language={language}/>

      <div className="AF-container">
        <div className="AF-pageContent">
          {/* <Banner /> */}

          <div className="grid-top">
            {/* Left Side */}
            <div className="col-8_lg-8_md-12_sm-12_xs-12">
              {/* <Video /> */}
              {/* <div className="grid-noGutter"><div className="space-5"></div></div> */}
              {/* <div className="AF-hr"></div> */}
              <div className="grid-noGutter space-1">
                <div className="space-5"></div>
              </div>
              <div id="component-best">
                <BestBet
                  oddsFormat={oddsFormat} 
                  language={language}
                />
              </div>

              {/* <BestBet /> */}

              <div className="grid-noGutter-middle">
                <div className="space-10"></div>
              </div>

              <div id="component-treble">
                <Treblewin
                  oddsFormat={oddsFormat}
                  leagueData={leagueData}
                  language={language}
                />
              </div>

              <div className="grid-noGutter-middle">
                <div className="space-10"></div>
              </div>

              {/* <LiveSoccerSpin />

					<div className="grid-noGutter-middle"><div className="space-10"></div></div>

					  <LiveSoccer /> */}
            </div>

            {/* right Side */}

            <div className="col-4_lg-4_md-12_sm-12_xs-12">
              <div className="AF-righSideBar">
                <div id="component-multi">
                  <MultiBets
                    oddsFormat={oddsFormat}
                    leagueData={leagueData}
                    language={language}
                  />
                </div>

                <div className="grid-noGutter">
                  <div className="space-10"></div>
                </div>

                {/* <DidYou /> */}

                {/* <div className="grid-noGutter"><div className="space-10"></div></div> */}

                {/* <RightLiveSoccerSpin /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      

      {showPopup && !blockPopup && (
        <div className="popup-overlay">
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="email-heder">Subscribe for Updates</h3>
            {showThankYouMessage && (
              <div className="thank-you-message">{showThankYouMessage}</div>
            )}
            <h4 className="popup-text">
              Be the first to access advanced features with more leagues and
              more markets. Leave your email and we’ll let you know when they’re
              live.
            </h4>
            <label className="form-label-email">Email</label>
            <input
              type="text"
              name="email"
              placeholder="Your@example.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {emailError && <p className="email-error-msg">{emailError}</p>}
            <div className="AF-buttonGroup-email">
              <button
                type="button"
                onClick={handleClose}
                className="AF-closeBtn-email"
              >
                Close
              </button>
              <button
                type="submit"
                className="AF-submitBtn-email"
                onClick={() => {
                  if (!validateEmail(formData.email)) {
                    setEmailError("Please enter a valid email address.");
                    return;
                  }
                  handleSave();
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Firstpage;
